export const pagesFleetsEn = {
  actions: {
    addMaintenance: 'Add Maintenance Record',
    addUsage: 'Add Usage Record',
    delete: 'Delete',
    edit: 'Edit',
    export: 'Export',
    print: 'Print',
    updateStatus: 'Update Status',
    viewDetails: 'View Details',
  },
  add: {
    buttons: {
      back: 'Back',
      cancel: 'Cancel',
      next: 'Next',
      save: 'Save',
      saveDraft: 'Save as Draft',
    },
    driveType: {
      awd: 'AWD',
      fourWd: '4WD',
      twoWd: '2WD',
    },
    engineType: {
      diesel: 'Diesel',
      electric: 'Electric',
      gasoline: 'Gasoline',
      hybrid: 'Hybrid',
      hydrogen: 'Hydrogen',
      phev: 'Plug-in Hybrid',
    },
    engineTypes: {
      DIESEL: 'Diesel',
      ELECTRIC: 'Electric',
      GASOLINE: 'Gasoline',
      HYBRID: 'Hybrid',
      HYDROGEN: 'Hydrogen',
      PLUGIN_HYBRID: 'Plug-in Hybrid',
    },
    fields: {
      aircraftRegistrationNumber: 'Aircraft Registration',
      aircraftType: 'Aircraft Type',
      assignedDepartment: 'Assigned Department',
      callSign: 'Call Sign',
      cruisingRange: 'Cruising Range',
      driveType: 'Drive Type',
      engineCount: 'Number of Engines',
      engineDisplacement: 'Engine Displacement',
      engineType: 'Engine Type',
      fleetName: 'Fleet Name',
      fuelEfficiency: 'Fuel Efficiency',
      fuelTankCapacity: 'Fuel Tank Capacity',
      fuelType: 'Fuel Type',
      homePort: 'Home Port',
      imo: 'IMO Number',
      inspectionExpiryDate: 'Inspection Expiry Date',
      insuranceAnnualPremium: 'Annual Premium',
      insuranceCoverage: 'Insurance Coverage',
      insuranceDeductible: 'Deductible',
      insuranceEndDate: 'Insurance End Date',
      insurancePolicyNumber: 'Insurance Policy Number',
      insuranceProvider: 'Insurance Provider',
      insuranceStartDate: 'Insurance Start Date',
      keyLocation: 'Key Location',
      licensePlateNumber: 'License Plate Number',
      manufacturer: 'Manufacturer',
      maximumTakeoffWeight: 'Maximum Takeoff Weight',
      model: 'Model',
      odometerReading: 'Odometer Reading',
      ownerPurpose: 'Ownership Purpose',
      ownershipType: 'Ownership Type',
      parkingSpotNumber: 'Parking Spot Number',
      passengerCapacity: 'Passenger Capacity',
      placeId: 'Place ID',
      registrationDate: 'Registration Date',
      registrationNumber: 'Registration Number',
      // Ship specific fields
      remarks: 'Remarks',
      responsiblePerson: 'Responsible Person',
      seatCapacity: 'Seat Capacity',
      serialNumber: 'Serial Number',
      shipType: 'Ship Type',
      status: 'Status',
      // Aircraft specific fields
      tonnage: 'Tonnage',
      transmission: 'Transmission',
      vehicleColor: 'Vehicle Color',
      vehicleType: 'Vehicle Type',
      vin: 'VIN',
      yearOfManufacture: 'Year of Manufacture',
    },
    fleetStatus: {
      ACTIVE: 'Active',
      DECOMMISSIONED: 'Decommissioned',
      DISPOSED: 'Disposed',
      INACTIVE: 'Inactive',
      MAINTENANCE: 'Under Maintenance',
    },
    licenseTypes: {
      large: 'Large',
      medium: 'Medium',
      ordinary: 'Ordinary',
    },
    maintenanceTypes: {
      CORRECTIVE: 'Corrective Maintenance',
      EMERGENCY: 'Emergency',
      INSPECTION: 'Inspection',
      OVERHAUL: 'Overhaul',
      PREVENTIVE: 'Preventive Maintenance',
    },
    navigation: {
      ship: {
        register: 'Register',
        toAccessoriesAssets: 'To Accessories & Assets',
        toMaintenanceComp: 'To Maintenance / Compliance',
        toMaintenanceCompliance: 'To Maintenance & Compliance',
        toOperationNav: 'To Operation & Navigation',
        toOwnershipManagement: 'To Ownership / Management',
        toOwnershipResponsibility: 'To Ownership & Responsibility',
        toPermitsLicenses: 'To Permits & Licenses',
        toShipIdInfo: 'To Ship ID Information',
        toTechnicalSpecs: 'To Technical Specifications',
      },
      vehicle: {
        register: 'Register',
        toAccessoriesPerm: 'to Accessories & Permits',
        toAccidentHistory: 'to Accident History',
        toDriverInformation: 'to Driver Information',
        toFuelManagement: 'to Fuel Management',
        toInsuranceInformation: 'to Insurance Information',
        toMaintenanceCompliance: 'To Maintenance & Compliance',
        toMaintenanceComplianceDetail: 'To Maintenance & Compliance(Details)',
        toOperationData: 'to Operation & Usage Data',
        toOwnershipResponsibility: 'To Ownership & Responsibility',
        toOwnershipResponsibilityDetail:
          'To Ownership & Responsibility(Detail)',
        toTechnicalSpecification: 'to Technical Specification',
        toVehicleIdInformation: 'to Veihicle ID Information',
        toVehicleUsageRecord: 'to Vehicle Usage Record',
      },
    },
    navigationTitles: {
      aircraft: 'Aircraft Registration',
      ship: 'Ship Registration',
      vehicle: 'Vehicle Registration',
    },
    optionalInsuranceStatus: {
      insured: 'Insured',
      not_insured: 'Not Insured',
      processing: 'Processing',
    },
    ownershipPurposes: {
      CARGO_TRANSPORT: 'Cargo Transport',
      COMMERCIAL_TRANSPORT: 'Commercial Transport',
      EXECUTIVE: 'Executive',
      INVESTIGATION: 'Investigation',
      LOGISTICS: 'Logistics',
      PASSENGER_SERVICE: 'Passenger Service',
      SALES: 'Sales',
      TRAINING: 'Training',
    },
    ownershipType: {
      leased: 'Leased',
      owned: 'Company Owned',
      rented: 'Rented',
    },
    ownershipTypes: {
      CAR_SHARE: 'Car Share',
      CHARTERED: 'Chartered',
      FINANCE_LEASE: 'Finance Lease',
      LEASED: 'Leased',
      OPERATIONAL_LEASE: 'Operational Lease',
      OTHER: 'Other',
      OWNED: 'Owned',
      RENTAL: 'Rental',
    },
    pageTitle: 'Add Fleet',
    placeholders: {
      accidentDescriptionDetail: 'Accident details',
      accidentLocationPlain: 'Accident location',
      accidentLogExample: 'Accident date, details, and response',
      aircraftRegistrationNumber: 'e.g., JA8089',
      aircraftType: 'e.g., Boeing 737',
      aisDataExample: 'Automatic Identification System data',
      amountYen: 'Amount',
      assignedDepartment: 'e.g., Sales Department',
      builderNameExample: 'Shipyard name (e.g., Mitsubishi Heavy Industries)',
      callSign: 'e.g., JA1234',
      cruisingRange: 'e.g., 5000',
      damageAmountYen: 'Damage amount',
      deadweightCapacity: 'Payload capacity',
      departureLocation: 'Departure location',
      destinationLocation: 'Destination',
      dimensionsExample: 'L×W×H (mm) e.g., 4500×1800×1500',
      distanceKm: 'km',
      driveType: 'Select drive type',
      driverIdPlain: 'Driver ID',
      driverLicenseInfoExample: 'License type, expiration date',
      driverNamePlaceholder: 'Driver name or Employee Number',
      electronicDevicesExample: 'e.g., GPS, radar, fish finder',
      emissionCertificatesExample: 'EEDI, SEEMP related',
      employeeIdDriver: 'Employee ID (assignable as driver)',
      engineCount: 'e.g., 2',
      engineDisplacement: 'e.g., 1800',
      engineDisplacementCC: 'cc (e.g., 1800)',
      engineType: 'Select engine type',
      firefightingEquipmentExample:
        'e.g., 20 fire extinguishers, 10 fire hoses',
      fleetIdUnique: 'Unique vehicle identifier',
      fleetName: 'e.g., Sales Vehicle 01',
      fuelAmountL: 'Fuel amount (L)',
      fuelAmountLiters: 'Liters (L)',
      fuelCapacityL: 'L',
      fuelCostYen: 'Fuel cost',
      fuelEfficiency: 'e.g., 25.5',
      // Additional vehicle registration placeholders
      fuelEfficiencyKmL: 'km/L (e.g., 15.5)',
      fuelStation: 'Refueling location',
      fuelTankCapacity: 'e.g., 50',
      fuelType: 'e.g., Regular',
      grossTonnagePlaceholder: 'Gross tonnage',
      homePort: 'e.g., Tokyo Port',
      homePortExample: 'Port name (e.g., Yokohama Port)',
      hoursUnit: 'Hours (h)',
      imo: 'e.g., 1234567',
      inspectionExpiryDate: 'Select date',
      inspectionLogExample: 'Periodic inspection, special inspection history',
      installedEquipmentExample: 'Dashcam, navigation, ETC, etc.',
      insuranceAnnualPremium: 'e.g., 1200',
      insuranceCompanyNamePlain: 'Insurance company name',
      insuranceCoverage: 'e.g., Full coverage',
      insuranceCoveragePlain: 'Insurance coverage',
      insuranceDeductible: 'e.g., 500',
      insuranceEndDate: 'Select date',
      insuranceInfoExample: 'Insurance company, policy number, expiry date',
      insurancePolicyNumber: 'e.g., 123456789',
      insurancePolicyNumberPlain: 'Insurance policy number',
      insuranceProvider: 'e.g., State Farm',
      insuranceStartDate: 'Select date',
      keyLocation: 'e.g., Admin Office Key Box',
      leaseCompanyName: 'Leasing company name',
      leaseContractNumber: 'Lease contract number',
      licenseNumberPlain: "Driver's license number",
      licensePlateExample: 'ABC 500 A 12-34',
      licensePlateNumber: 'e.g., ABC-1234',
      maintenanceDescriptionDetail: 'Enter maintenance details',
      maintenanceHistoryExample:
        'Date, maintenance details, service shop, etc.',
      maintenanceIdExample: 'V-2024-001',
      maintenanceLogExample: 'Repair and dry-dock records',
      maintenanceProviderExample:
        'Service company or internal maintenance staff',
      managementCompanyName: 'Operation management company name',
      manufacturer: 'e.g., Toyota',
      manufacturerExample: 'e.g., Toyota',
      maxPayloadKg: 'Load capacity (kg)',
      maximumTakeoffWeight: 'e.g., 79000',
      model: 'e.g., Prius',
      modelExample: 'e.g., Prius ZVW30',
      nauticalMilesUnit: 'Nautical miles (NM)',
      nextMaintenanceDate: 'Select date',
      odometerKm: 'km',
      odometerReading: 'e.g., 12500',
      operationDepartmentExample: 'e.g., Sales Department, Shipping Department',
      operationHours: 'Hours (for construction/special vehicles)',
      operationLogExample: 'Departure/return time, mileage, driver, etc.',
      ownerNamePlain: 'Company/Individual name',
      ownershipType: 'Select ownership type',
      parkingSpotNumber: 'e.g., A-15',
      passengerCapacity: 'e.g., 189',
      placeId: 'Select place',
      placeSelect: 'Select location (branch office, etc.)',
      recallInfoExample: 'Manufacturer recall information',
      registrationDate: 'Select date',
      registrationNumber: 'e.g., JPN-123456',
      remarks: 'Enter notes or special remarks',
      repairLogExample: 'Breakdown date, repair records',
      responsiblePerson: 'e.g., John Doe',
      responsiblePersonExample: 'Department manager or IT administrator',
      seatCapacity: 'e.g., 5',
      seatCapacityPeople: 'Maximum passenger capacity',
      selectDepartment: 'Select department',
      selectDriveType: 'Select drive type',
      selectEngineType: 'Select engine type',
      selectFuelType: 'Select fuel type',
      selectHomePort: 'Select home port',
      selectLicenseType: 'Select license type',
      selectMaintenanceType: 'Select maintenance type',
      selectNavigationArea: 'Please select',
      selectOptionalInsurance: 'Select coverage status',
      selectOwnerPurpose: 'Select owner purpose',
      selectOwnershipType: 'Select ownership type',
      selectPropulsionType: 'Please select',
      selectRepairStatus: 'Select repair status',
      selectShipType: 'Please select',
      selectStatus: 'Select status',
      selectTransmission: 'Select transmission',
      selectUsagePurpose: 'Select usage purpose',
      selectVehicleCategory: 'Select vehicle category',
      selectVehicleType: 'Select vehicle type',
      serialNumber: 'e.g., ABC123456',
      serialNumberPlain: 'Serial number',
      shipFleetIdPlaceholder: 'Unique vessel identifier',
      shipManufacturerExample: 'e.g., Mitsubishi Heavy Industries',
      shipModelExample: 'e.g., Container Ship 2000',
      shipNameExample: 'e.g., Ocean Star',
      shipSerialNumber: 'Hull number',
      shipType: 'e.g., Cargo Ship',
      specialNavigationPermitExample: 'Dangerous goods loading permit, etc.',
      specialPermitExample: 'Highway permit, heavy load permit, etc.',
      tokyoOfficeBranchExample: 'e.g., Tokyo HQ, Osaka Branch',
      tonnage: 'e.g., 5000',
      transmission: 'Select transmission',
      usagePurpose: 'e.g., Sales activities',
      usagePurposePlain: 'Usage purpose',
      // Ship specific placeholders
      utilizationRatePercent: 'Utilization rate (%)',
      vehicleColor: 'e.g., White',
      vehicleColorWhite: 'White',
      vehicleSensorsExample: 'Collision prevention, backup camera, etc.',
      vehicleType: 'e.g., Sedan',
      vehicleWeightKg: 'Vehicle weight (kg)',
      // Aircraft specific placeholders
      vin: 'e.g., JHMCM56557C404453',
      vinExample: 'JH4DC4450RS123456',
      voyageLogExample: 'Departure port, arrival port, voyage time, etc.',
      yearFormat: 'YYYY',
      yearOfManufacture: 'e.g., 2023',
      yearPlaceholder: 'YYYY',
    },
    progressbar: {
      fieldsCompleted: 'Completed',
      fieldsTotal: 'Total',
      filled: 'Filled',
      left: '{{value}} fields remaining',
      modeSetting: 'Input Mode Setting',
      mustItem: 'Required Fields',
      mustItemOnly: 'Required Only',
      title: 'Progress',
      total: 'All Fields',
    },
    reservationStatuses: {
      AVAILABLE: 'Available',
      CLEANING: 'Cleaning',
      IN_USE: 'In Use',
      INSPECTION: 'Inspection',
      MAINTENANCE: 'Maintenance',
      NOT_AVAILABLE: 'Not Available',
      RESERVED: 'Reserved',
      STORED: 'Stored',
    },
    sections: {
      aircraftDetails: 'Aircraft Details',
      basicInfo: 'Basic Information',
      dimensions: 'Dimensions & Weight',
      driverInfo: 'Driver Information',
      engineSpecs: 'Engine Specifications',
      insuranceInfo: 'Insurance Information',
      placementInfo: 'Placement Information',
      shipDetails: 'Ship Details',
      technicalSpecs: 'Technical Specifications',
      vehicleDetails: 'Vehicle Details',
    },
    shipTypes: {
      BARGE: 'Barge',
      BULK_CARRIER: 'Bulk carrier',
      CONTAINER: 'Container ship',
      CRUISE: 'Cruise ship',
      FERRY: 'Ferry',
      FISHING: 'Fishing vessel',
      PASSENGER: 'Passenger ship',
      PATROL: 'Patrol boat',
      RESEARCH: 'Research vessel',
      RORO: 'Roll-on/Roll-off ship',
      TANKER: 'Tanker',
      TUG: 'Tug boat',
      WORK_BOAT: 'Work boat',
      YACHT: 'Yacht',
    },
    status: {
      available: 'Available',
      disposed: 'Disposed',
      inUse: 'In Use',
      maintenance: 'Under Maintenance',
      retired: 'Retired',
    },
    stepper: {
      assignment: 'Insurance Info',
      basic: 'Basic Info',
      confirm: 'Confirm',
      drivers: 'Drivers',
      identification: 'Vehicle Details',
      insurance: 'Insurance',
      placement: 'Placement & Responsible',
      vehicle: 'Vehicle Details',
    },
    title: 'Add Fleet',
    transmission: {
      at: 'AT',
      cvt: 'CVT',
      dct: 'DCT',
      mt: 'MT',
    },
    validation: {
      duplicateFleetId: 'This Fleet ID is already in use',
      duplicateLicensePlate: 'This license plate is already registered',
      duplicateVin: 'This VIN is already registered',
      invalidFormat: 'Invalid format',
      required: 'This field is required',
    },
  },
  addSelect: {
    body: {
      aircraft: 'Aircraft',
      automobile: 'Automobile',
      fillOutDetails: 'Fill Out Details',
      itemCard: {
        aircraftRegistrationNumber: 'Aircraft Registration Number',
        aircraftType: 'Aircraft Type',
        fleetName: 'Fleet Name',
        licensePlateNumber: 'License Plate Number',
        manufacturer: 'Manufacturer',
        model: 'Model',
        registrationNumber: 'Registration Number',
        requiredDetails: 'Required Details',
        shipType: 'Ship Type',
        tonnage: 'Tonnage',
      },
      selectFleetType: 'Select the type of fleet to add',
      ship: 'Ship',
    },
    header: {
      headerTitle: 'Select Fleet Type',
    },
    options: {
      bulkCsvUpload: {
        title: 'Bulk Upload via CSV',
      },
      description: 'Other Options',
      syncFleetManagement: 'Sync with Fleet Management System',
    },
  },
  detail: {
    driveType: {
      awd: 'AWD',
      fourWd: '4WD',
      twoWd: '2WD',
    },
    driveTypes: {
      AWD: 'AWD',
      FF: 'FF (Front-Wheel Drive)',
      FOUR_WD: '4WD',
      FR: 'FR (Rear-Wheel Drive)',
      MR: 'MR (Mid-Engine)',
      RR: 'RR (Rear-Engine)',
      TWO_WD: '2WD',
    },
    engineType: {
      diesel: 'Diesel',
      electric: 'Electric',
      gasoline: 'Gasoline',
      hybrid: 'Hybrid',
      hydrogen: 'Hydrogen',
      phev: 'Plug-in Hybrid',
    },
    engineTypes: {
      DIESEL: 'Diesel',
      ELECTRIC: 'Electric',
      GASOLINE: 'Gasoline',
      HYBRID: 'Hybrid',
      HYDROGEN: 'Hydrogen',
      PLUGIN_HYBRID: 'Plug-in Hybrid',
    },
    fields: {
      accidentLog: 'Accident Log',
      acquisitionCost: 'Acquisition Cost',
      acquisitionDate: 'Acquisition Date',
      aisData: 'AIS Data',
      aisDataSummary: 'AIS Information',
      anchorType: 'Anchor Type',
      assetTag: 'Asset Tag',
      assignedDepartment: 'Assigned Department',
      ballastCapacity: 'Ballast Capacity',
      berthingLocation: 'Berthing Location',
      bookValue: 'Book Value',
      breadth: 'Breadth',
      buildDate: 'Build Date',
      builder: 'Builder',
      callSign: 'Call Sign',
      captain: 'Captain',
      cargoGear: 'Cargo Gear',
      cargoPermit: 'Cargo Permit',
      charterer: 'Charterer',
      chiefEngineer: 'Chief Engineer',
      classCertificateExpiry: 'Class Certificate Expiry',
      classification: 'Classification',
      classificationSociety: 'Classification Society',
      communicationEquipment: 'Communication Equipment',
      cost: 'Cost',
      crewCapacity: 'Crew Capacity',
      crewingAgent: 'Crewing Agent',
      curbWeight: 'Curb Weight (kg)',
      currentVoyageStatus: 'Current Voyage Status',
      deadweightTonnage: 'Deadweight Tonnage',
      department: 'Department',
      depreciationMethod: 'Depreciation Method',
      description: 'Description',
      dimensionHeight: 'Height (mm)',
      dimensionLength: 'Length (mm)',
      dimensionWidth: 'Width (mm)',
      distanceTraveled: 'Distance (km)',
      documentName: 'Document Name',
      documentType: 'Document Type',
      draft: 'Draft',
      driveType: 'Drive Type',
      driverName: 'Driver Name',
      driverUserId: ' Driver ID',
      electronicDevices: 'Electronic Devices',
      emissionCertificates: 'Emission Certificates',
      // GPS Information
      endDatetime: 'End Date/Time',
      endLocation: 'End Location',
      engineDisplacement: 'Engine Displacement (cc)',
      engineSpecs: 'Engine Specs',
      // Dimensions & Weight
      engineType: 'Engine Type',
      expiryDate: 'Expiry Date',
      firefightingEquipment: 'Firefighting Equipment',
      fishingLicense: 'Fishing License',
      flagState: 'Flag State',
      // Engine & Fuel
      fleetCategory: 'Category',
      fleetId: 'Fleet ID',
      fleetName: 'Fleet Name',
      // Operation Info
      fleetType: 'Type',
      fuelCapacity: 'Fuel Capacity',
      fuelEfficiency: 'Fuel Efficiency (km/L)',
      // Insurance Details
      fuelTankCapacity: 'Fuel Tank Capacity (L)',
      fuelType: 'Fuel Type',
      // Driver Information
      fuelUsed: 'Fuel Used (L)',
      gpsCurrentLat: 'Current Latitude',
      gpsCurrentLng: 'Current Longitude',
      gpsCurrentPosition: 'Current Position',
      gpsTrackingData: 'GPS Tracking',
      grossTonnage: 'Gross Tonnage',
      // Document Information
      homePort: 'Home Port',
      hullNumber: 'Hull Number',
      imoNumber: 'IMO Number',
      inspectionExpiryDate: 'Inspection Expiry Date',
      inspectionLog: 'Inspection Log',
      insuranceAgent: 'Insurance Agent',
      // Usage History
      insuranceAnnualPremium: 'Annual Premium',
      insuranceCompany: 'Insurance Company',
      insuranceCoverage: 'Coverage',
      insuranceDeductible: 'Deductible',
      insuranceEndDate: 'Insurance End Date',
      insuranceExpiry: 'Insurance Expiry',
      insuranceInfo: 'Insurance Info',
      // Maintenance History
      insurancePolicyNumber: 'Insurance Policy Number',
      insuranceProvider: 'Insurance Provider',
      insuranceStartDate: 'Insurance Start Date',
      ismCertificate: 'ISM Certificate',
      ismCertificateExpiry: 'ISM Certificate',
      ispsCertificate: 'ISPS Certificate',
      ispsCertificateExpiry: 'ISPS Certificate',
      lastArrival: 'Last Arrival',
      // Ship detail fields
      lastDeparture: 'Last Departure',
      lastMaintenanceDate: 'Last Maintenance Date',
      lastOperationDate: 'Last Operation Date',
      leaseCompany: 'Lease Company',
      leaseContractId: 'Lease Contract ID',
      lengthOverall: 'Length Overall',
      licenseExpirationDate: 'License Expiration Date',
      licenseExpiryDate: 'License Expiry Date',
      licenseNumber: 'License Number',
      licensePlateNumber: 'License Plate',
      licenseType: 'License Type',
      lifeboatCount: 'Lifeboat Count',
      lifejacketCount: 'Lifejacket Count',
      liferaftCount: 'Life Raft Count',
      maintenance: {
        cost: 'Maintenance Cost',
        date: 'Maintenance Date',
        description: 'Work Description',
        id: 'Maintenance ID',
        provider: 'Service Provider',
        type: 'Maintenance Type',
      },
      maintenanceCost: 'Cost',
      maintenanceDate: 'Maintenance Date',
      maintenanceDescription: 'Work Description',
      maintenanceId: 'Maintenance ID',
      maintenanceLog: 'Maintenance Log',
      maintenanceProvider: 'Service Provider',
      maintenanceType: 'Maintenance Type',
      managementCompany: 'Management Company',
      manager: 'Manager',
      manufacturer: 'Manufacturer',
      maxPayload: 'Max Payload (kg)',
      maximumPayload: 'Maximum Payload',
      mmsiNumber: 'MMSI Number',
      model: 'Model',
      mortgageStatus: 'Mortgage Status',
      navigationArea: 'Navigation Area',
      navigationSystemType: 'Navigation System Type',
      nextDockingDate: 'Next Docking Date',
      nextInspectionDate: 'Next Inspection Date',
      nextMaintenanceDate: 'Next Maintenance Date',
      odometerReading: 'Odometer Reading',
      operatingPermit: 'Operating Permit',
      operationDepartment: 'Operation Department',
      operationLog: 'OperationLog',
      operationalManager: 'Operational Manager',
      operationalManagerId: 'Operational Manager',
      operator: 'Operator',
      optionalInsuranceStatus: 'Optional Insurance',
      ownerName: 'Owner Name',
      ownerPurpose: 'Ownership Purpose',
      ownershipType: 'Ownership Type',
      passengerCapacity: 'Passenger Capacity',
      placeId: 'Location',
      placeName: 'Location Name',
      propulsionType: 'Propulsion Type',
      purpose: 'Purpose',
      radioLicense: 'Radio License',
      radioLicenseExpiry: 'Radio License Expiry Date',
      registrationDate: 'Registration Date',
      // Additional Ship specific fields
      remarks: 'Remarks',
      reservationStatus: 'reservationStatus',
      responsiblePerson: 'Responsible Person',
      seatCapacity: 'Seat Capacity',
      serialNumber: 'Serial Number',
      shipId: 'Ship ID',
      shipName: 'Ship Name',
      shipOwner: 'Ship Owner',
      shipType: 'Ship Type',
      specialNavigationPermit: 'Special Navigation Permit',
      startDatetime: 'Start Date/Time',
      startLocation: 'Start Location',
      status: 'Status',
      technicalManager: 'Technical Manager',
      totalOperationHours: 'Total Operation Hours',
      totalVoyageDistance: 'Total Voyage Distance',
      totalVoyageHours: 'Total Voyage Hours',
      tradingArea: 'Trading Area',
      transmission: 'Transmission',
      uploadedAt: 'Uploaded At',
      // Additional missing fields
      uploadedBy: 'Uploaded By',
      usagePurpose: 'Usage Purpose',
      utilizationRate: 'Utilization Rate',
      vehicleCategory: 'Vehicle Category',
      // Additional missing fields
      vehicleColor: 'Vehicle Color',
      vehicleDimensions: 'Vehicle Dimensions',
      vehicleId: 'Vehicle ID',
      vehicleType: 'Vehicle Type',
      vehicleUsagePurposes: 'Vehicle Usage Purposes',
      vesselLicense: 'Vessel License',
      vesselLicenseExpiry: 'Vessel License Expiry Date',
      vin: 'VIN',
      voyageLog: 'Voyage Log',
      yearOfManufacture: 'Year of Manufacture',
    },
    fuelTypes: {
      AVGAS: 'Aviation Gasoline',
      BIOFUEL: 'Biofuel',
      DIESEL: 'Diesel',
      ELECTRIC: 'Electric',
      GASOLINE: 'Gasoline',
      HFO: 'Heavy Fuel Oil',
      HYBRID_DIESEL: 'Hybrid (Diesel)',
      HYBRID_GASOLINE: 'Hybrid (Gasoline)',
      HYDROGEN: 'Hydrogen',
      JET_FUEL: 'Jet Fuel',
      LNG: 'Liquefied Natural Gas',
      LPG: 'Liquefied Petroleum Gas',
      MGO: 'Marine Gas Oil',
    },
    licenseTypes: {
      large: 'Large',
      medium: 'Medium',
      ordinary: 'Ordinary',
    },
    navigationAreas: {
      COASTAL: 'Coastal',
      INLAND: 'Inland',
      INTERNATIONAL: 'International',
      NEAR_COASTAL: 'Near Coastal',
      OCEAN_GOING: 'Ocean Going',
      PORT_LIMIT: 'Port Limit',
      SMOOTH_WATER: 'Smooth Water',
    },
    optionalInsuranceStatus: {
      insured: 'Insured',
      not_insured: 'Not Insured',
      processing: 'Processing',
    },
    ownerPurposes: {
      BUSINESS_USE: 'Business Use',
      COMMERCIAL_TRANSPORT: 'Commercial Transport',
      INVESTIGATION: 'Investigation',
      OTHER: 'Other',
      TRAINING: 'Training',
    },
    ownershipPurposes: {
      CARGO_TRANSPORT: 'Cargo Transport',
      COMMERCIAL_TRANSPORT: 'Commercial Transport',
      EXECUTIVE: 'Executive',
      INVESTIGATION: 'Investigation',
      LOGISTICS: 'Logistics',
      PASSENGER_SERVICE: 'Passenger Service',
      SALES: 'Sales',
      TRAINING: 'Training',
    },
    ownershipTypes: {
      CAR_SHARE: 'Car Share',
      CHARTERED: 'Chartered',
      FINANCE_LEASE: 'Finance Lease',
      LEASED: 'Leased',
      OPERATIONAL_LEASE: 'Operational Lease',
      OTHER: 'Other',
      OWNED: 'Owned',
      RENTAL: 'Rental',
    },
    pageTitle: 'Fleet Detail',
    propulsionTypes: {
      AZIMUTH: 'Azimuth Thruster',
      HYBRID: 'Hybrid',
      PADDLE_WHEEL: 'Paddle Wheel',
      POD: 'Pod Propulsion',
      SAIL: 'Sail',
      SCREW: 'Screw Propeller',
      WATER_JET: 'Water Jet',
    },
    repairStatuses: {
      REPAIRED: 'Repaired',
      REPAIRING: 'Under Repair',
      SCRAPPED: 'Scrapped',
    },
    reservationStatuses: {
      AVAILABLE: 'Available',
      CLEANING: 'Cleaning',
      IN_USE: 'In Use',
      INSPECTION: 'Inspection',
      MAINTENANCE: 'Maintenance',
      NOT_AVAILABLE: 'Not Available',
      RESERVED: 'Reserved',
    },
    sections: {
      accessoriesAssetTracking: 'Accessories & Asset Tracking',
      accessoriesAssets: 'Accessories / Asset Management',
      aircraftDetails: 'Aircraft Details',
      basicInfo: 'Basic Information',
      dimensions: 'Dimensions & Weight',
      documents: 'Documents',
      drivers: 'Driver Information',
      fleetIdInformation: 'Fleet ID Information',
      gpsInfo: 'GPS Information',
      insurance: 'Insurance',
      maintenanceCompliance: 'Maintenance & Compliance',
      maintenanceComplianceShip: 'Maintenance / Compliance',
      maintenanceHistory: 'Maintenance History',
      // Fleet common categories
      operationNavigation: 'Operation & Navigation',
      operationNavigationInfo: 'Operation / Navigation Information',
      operationNavigationShip: 'Operation & Navigation',
      ownershipInfo: 'Ownership & Contract',
      // Ship specific categories
      ownershipManagement: 'Ownership / Management',
      ownershipResponsibility: 'Ownership & Responsibility',
      permitsLicenses: 'Permits / Licenses',
      shipDetails: 'Ship Details',
      shipIdInformation: 'Ship ID Information',
      technicalSpecifications: 'Technical Specifications',
      technicalSpecs: 'Technical Specifications',
      usageHistory: 'Usage History',
      vehicleDetails: 'Vehicle Details',
    },
    tabs: {
      basic: 'Basic Info',
      documents: 'Documents',
      drivers: 'Drivers',
      insurance: 'Insurance',
      maintenance: 'Maintenance History',
      usage: 'Usage History',
      vehicle: 'Vehicle Details',
    },
    transmission: {
      at: 'Automatic',
      cvt: 'CVT',
      dct: 'Dual Clutch',
      mt: 'Manual',
    },
    transmissionTypes: {
      AMT: 'AMT',
      AT: 'Automatic',
      CVT: 'CVT',
      DCT: 'Dual Clutch',
      ELECTRIC: 'Electric (EV)',
      MT: 'Manual',
    },
    vehicle: {
      categories: {
        'accessories-permits': 'Accessories & Permits',
        'accident-history': 'Accident History',
        accidents: 'Accidents',
        'basic-information': 'Basic Information',
        'driver-information': 'Driver Information',
        drivers: 'Drivers',
        'fleet-usage': 'Fleet Usage',
        'fuel-management': 'Fuel Management',
        'fuel-records': 'Fuel Records',
        insurance: 'Insurance',
        'insurance-information': 'Insurance Information',
        'location-gps': 'Location & GPS',
        'maintenance-compliance': 'Maintenance & Compliance',
        'maintenance-compliance-detail': 'Maintenance & Compliance (Detail)',
        'maintenance-management': 'Maintenance Management',
        'operation-usage': 'Operation & Usage Data',
        'ownership-information': 'Ownership Information',
        'ownership-management': 'Ownership & Management',
        'ownership-responsibility': 'Ownership & Responsibility',
        'ownership-responsibility-detail':
          'Ownership & Responsibility (Detail)',
        'system-information': 'System Information',
        'technical-specifications': 'Technical Specifications',
        'vehicle-fleet-id': 'Vehicle ID Information',
        'vehicle-id-information': 'Vehicle ID Information',
        'vehicle-usage-record': 'Vehicle Usage Record',
      },
      fields: {
        accidentDriverName: 'Accident Driver Name',
        assignedDepartment: 'Assigned Department',
        assignedDriverId: 'Assigned Driver ID',
        assignedUser: 'Assigned User',
        assignedUserId: 'Assigned User',
        curbWeight: 'Curb Weight',
        damageCost: 'Damage Cost',
        dashcam: 'Dash Camera',
        dimensionHeight: 'Vehicle Dimensions (Height)',
        dimensionLength: 'Vehicle Dimensions (Length)',
        dimensionWidth: 'Vehicle Dimensions (Width)',
        distanceTraveled: 'Distance Traveled',
        driveType: 'Drive Type',
        driverId: 'Driver ID',
        driverName: 'Used Driver Name',
        endDatetime: 'End Datetime',
        endLocation: 'End Location',
        engineDisplacement: 'Engine Displacement',
        engineType: 'Engine Type',
        etcDevice: 'ETC Device',
        fleetId: 'Fleet ID',
        fleetName: 'Fleet Name',
        fleetType: 'Fleet Type',
        fuelAmount: 'Fuel Amount',
        fuelCost: 'Fuel Cost',
        fuelEfficiency: 'Fuel Efficiency',
        fuelOdometer: 'Odometer',
        fuelRemarks: 'Fuel Remarks',
        fuelStation: 'Fuel Station',
        fuelTankCapacity: 'Fuel Tank Capacity',
        fuelTotalCost: 'Fuel Cost',
        fuelType: 'Fuel Type',
        fuelUnitPrice: 'Unit Price',
        fuelUsed: 'Fuel Used',
        gpsTrackingDevice: 'GPS Tracking Device',
        inspectionExpiryDate: 'Inspection Expiry Date',
        installedEquipment: 'Installed Equipment',
        insuranceInformation: 'Insurance Information',
        lastOperationDate: 'Last Operation Date',
        licensePlateNumber: 'License Plate Number',
        location: 'Location',
        maintenanceCost: 'Maintenance Cost',
        maintenanceDate: 'Maintenance Date',
        maintenanceDescription: 'Maintenance Description',
        maintenanceHistory: 'Maintenance History',
        maintenanceProvider: 'Maintenance Provider',
        maintenanceType: 'Maintenance Type',
        manufacturer: 'Manufacturer',
        maxPayload: 'Maximum Payload',
        maximumPayload: 'Maximum Payload',
        model: 'Model',
        nextMaintenanceDate: 'Next Maintenance Due',
        nextMaintenanceDue: 'Next Maintenance Due',
        odometerReading: 'Odometer Reading',
        operationLog: 'Operation Log',
        optionalInsuranceStatus: 'Optional Insurance Status',
        ownerPurpose: 'Ownership Purpose',
        parkingLocation: 'Parking Location',
        recallInfo: 'Recall Information',
        refuelDate: 'Refuel Date',
        registrationDate: 'Registration Date',
        repairLog: 'Repair Log',
        reservationStatus: 'Reservation Status',
        responsiblePerson: 'Responsible Person',
        roadTaxExpiryDate: 'Road Tax Due Date',
        seatCapacity: 'Seat Capacity',
        selectDriver: 'Select Driver',
        serialNumber: 'Serial Number',
        specialPermit: 'Special Permit',
        startDatetime: 'Start Datetime',
        startLocation: 'Start Location',
        status: 'Status',
        totalOperationHours: 'Total Operation Hours',
        transmission: 'Transmission',
        usageDistance: 'Distance Traveled',
        usageEndDate: 'End Datetime',
        usagePurpose: 'Usage Purpose',
        usagePurposeDetail: 'Purpose',
        usageRemarks: 'Usage Remarks',
        usageStartDate: 'Start Datetime',
        usageUserId: 'Driver ID',
        utilizationRate: 'Utilization Rate',
        vehicleCategory: 'Vehicle Category',
        vehicleColor: 'Vehicle Color',
        vehicleDimensions: 'Vehicle Dimensions',
        vehicleId: 'Vehicle ID',
        vehicleModel: 'Model',
        vehicleSensors: 'Vehicle Sensors',
        vehicleType: 'Vehicle Type',
        vehicleUsagePurposes: 'Vehicle Usage Purposes',
        vin: 'Vehicle Identification Number (VIN)',
        yearOfManufacture: 'Year of Manufacture',

        accidentDate: 'Accident Date',
        accidentDescription: 'Accident Description',
        accidentInsuranceClaim: 'Insurance Claim',
        accidentLocation: 'Location',
        accidentRepairCost: 'Damage Cost',
        accidentReportNumber: 'Report Number',
        accidentSeverity: 'Accident Severity',
        coverage: 'Coverage',
        createdAt: 'Created Date',
        driverAssignedDate: 'Assignment Date',
        driverIsPrimary: 'Primary Driver',
        driverLicenseExpiry: 'Expiration Date',
        driverLicenseInfo: 'Driver License Info',
        driverLicenseNumber: 'License Number',
        driverLicenseType: 'License Type',
        driverUserId: 'Driver ID',
        endDate: 'End Date',
        gpsCurrentLat: 'Current Latitude',
        gpsCurrentLng: 'Current Longitude',
        gpsTrackingData: 'GPS Tracking Data',
        insuranceCompany: 'Provider',
        insuranceCoverage: 'Coverage',
        insuranceEndDate: 'End Date',
        insurancePolicyNumber: 'Policy Number',
        insurancePremium: 'Insurance Premium',
        insuranceStartDate: 'Insurance Start Date',
        insuranceType: 'Insurance Type',
        leaseCompany: 'Lease Company',
        leaseContractId: 'Lease Contract ID',
        licenseExpirationDate: 'License Expiration Date',
        licenseNumber: 'License Number',
        licenseType: 'License Type',
        ownerName: 'Owner Name',
        ownershipType: 'Ownership Type',
        placeId: 'Place ID',
        policyNumber: 'Policy Number',
        provider: 'Provider',
        remarks: 'Remarks',
        repairStatus: 'Repair Status',
        startDate: 'Start Date',
        updatedAt: 'Updated Date',
      },
      noVehicleData: 'No vehicle data available',
    },
    vehicleBodyTypes: {
      BUS: 'Bus',
      COUPE: 'Coupe',
      FORKLIFT: 'Forklift',
      HATCHBACK: 'Hatchback',
      MICROBUS: 'Microbus',
      MINIVAN: 'Minivan',
      MOTORCYCLE: 'Motorcycle',
      PICKUP: 'Pickup',
      SEDAN: 'Sedan',
      SPECIAL_PURPOSE: 'Special Purpose',
      SUV: 'SUV',
      TRUCK: 'Truck',
      VAN: 'Van',
      WAGON: 'Wagon',
    },
    vehicleCategories: {
      AGRICULTURAL: 'Agricultural Vehicle',
      CONSTRUCTION: 'Construction Vehicle',
      DELIVERY: 'Delivery Vehicle',
      EMERGENCY: 'Emergency Vehicle',
      EXECUTIVE: 'Executive Vehicle',
      RENTAL: 'Rental Car',
      SALES: 'Sales Vehicle',
      SERVICE: 'Service Vehicle',
      SHUTTLE: 'Shuttle Vehicle',
    },
    vehicleUsagePurposes: {
      CARGO_TRANSPORT: 'Cargo Transport',
      COMMERCIAL_TRANSPORT: 'Commercial Transport',
      COMMUTE: 'Commute',
      EMERGENCY: 'Emergency',
      EXECUTIVE: 'Executive',
      INVESTIGATION: 'Investigation',
      LOGISTICS: 'Logistics',
      MAINTENANCE_SUPPORT: 'Maintenance Support',
      OTHER: 'Other',
      PASSENGER_SERVICE: 'Passenger Service',
      SALES: 'Sales',
      TRAINING: 'Training',
    },
  },
  list: {
    addFleet: 'Add Fleet',
    filterPlaceholder: 'Search fleet...',
    filters: {
      assignedWorker: 'Assigned Worker',
      fleetCategory: 'Fleet Category',
      fleetType: 'Fleet Type',
      placementPlace: 'Placement Place',
      status: 'Status',
    },
    mainType: {
      aircraft: 'Aircraft',
      all: 'All',
      ship: 'Ships',
      vehicle: 'Vehicles',
    },
    pageTitle: 'Fleets',
    status: {
      available: 'Available',
      disposed: 'Disposed',
      inUse: 'In Use',
      maintenance: 'Maintenance',
      retired: 'Retired',
    },
    table: {
      headers: {
        assignedPlace: 'Assigned Place',
        assignedWorker: 'Assigned Worker',
        createdAt: 'Created At',
        fleetCategory: 'Category',
        fleetId: 'Fleet ID',
        fleetName: 'Fleet Name',
        fleetType: 'Type',
        model: 'Model',
        status: 'Status',
      },
    },
    tabs: {
      all: 'All',
      available: 'Available',
      inUse: 'In Use',
      maintenance: 'Maintenance',
      retired: 'Retired',
    },
  },
  listTab: 'Fleet List',
  messages: {
    createSuccess: 'Fleet created successfully',
    deleteSuccess: 'Fleet deleted successfully',
    error: 'An error occurred',
    maintenanceAddSuccess: 'Maintenance record added successfully',
    statusUpdateSuccess: 'Status updated successfully',
    updateSuccess: 'Fleet updated successfully',
    usageAddSuccess: 'Usage record added successfully',
  },
  settings: {
    dialog: {
      addTitle: 'Add',
      deleteMessage:
        'Are you sure you want to delete? This action cannot be undone.',
      deleteTitle: 'Delete Confirmation',
      disableMessage: 'Do you want to disable?',
      disableTitle: 'Disable',
      editTitle: 'Edit',
      enableMessage: 'Do you want to enable?',
      enableTitle: 'Enable',
    },
    fleetCategories: {
      addButton: 'Add Category',
      table: {
        actions: 'Actions',
        description: 'Description',
        isEnabled: 'Enabled',
        name: 'Category Name',
        type: 'Type',
      },
      title: 'Fleet Categories',
    },
    fleetTypes: {
      addButton: 'Add Type',
      table: {
        actions: 'Actions',
        description: 'Description',
        isEnabled: 'Enabled',
        name: 'Type Name',
      },
      title: 'Fleet Types',
    },
    tabs: {
      categories: 'Fleet Categories',
      types: 'Fleet Types',
    },
    title: 'Fleet Settings',
  },
  title: 'Fleets',
};
